<template>
  <div>
    <the-breadcrumbs></the-breadcrumbs>
    <page-content page-title="Textbausteine">
      <template #actions>
        <region-chooser
          v-if="$store.getters['auth/isSuperAdmin']"
          @region:chosen="loadSettings"
        ></region-chooser>
      </template>
      <region-text-settings-form
        :loading="loading"
        :settings="settings"
        :form-submitted="saveSettings"
      ></region-text-settings-form>
    </page-content>
  </div>
</template>

<script>
import TheBreadcrumbs from "@/components/TheBreadcrumbs"
import PageContent from "@/components/PageContent"
import RegionChooser from "@/components/RegionChooser"
import RegionRepository from "@/repositories/region_repository.js"
import RegionTextSettingsForm from "@/components/forms/RegionTextSettingsForm"
import ApiErrorHandlerMixin from "@/mixins/api_error_handler.js"

export default {
  metaInfo: {
    title: "Textbausteine"
  },
  components: {
    TheBreadcrumbs,
    PageContent,
    RegionChooser,
    RegionTextSettingsForm
  },
  mixins: [ApiErrorHandlerMixin],
  data() {
    return {
      loading: false,
      settings: {}
    }
  },
  async created() {
    this.loadSettings()
  },
  methods: {
    async loadSettings() {
      this.loading = true

      try {
        let data = await RegionRepository.getSettings()
        this.settings = data.text_snippet_settings
        this.loading = false
      } catch (error) {
        this.loading = false
        this.handleApiError(error)
      }
    },
    async saveSettings(settings) {
      await RegionRepository.updateSettings(settings)
    }
  }
}
</script>
